import actions from "./actions.js";
import mutations from "./mutations.js";

export const initialState = () => {
  return {};
};

export const clipboardModule = {
  state: initialState(),
  namespaced: true,
  actions,
  mutations
};
